import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=643f076e&scoped=true&"
import script from "./Like.vue?vue&type=script&lang=ts&"
export * from "./Like.vue?vue&type=script&lang=ts&"
import style0 from "./Like.vue?vue&type=style&index=0&id=643f076e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f076e",
  null
  
)

export default component.exports